export { getFieldConfig, searchAssets } from './assets';
